import { Panel, ToolButton, Typography } from "@maxhub/max-ui";
import styles from "./tabBar.module.css";
import { TabBar_Camera, TabBar_Devices, TabBar_Profile } from "../icons/icons";
import { useRef } from "react";

type TabBarProps = {
  onScanClick: () => void;
  onDevicesClick: () => void;
  onSettingsClick: () => void;
  ScanText: string;
  DevicesText: string;
  SettingsText: string;
};

export const TabBar = ({
  onScanClick,
  onDevicesClick,
  onSettingsClick,
  ScanText,
  DevicesText,
  SettingsText,
}: TabBarProps) => {
  const profileRef = useRef<HTMLDivElement>(null);
  return (
    <>
      <div className={styles.spacer} />

      <div className={styles.tabBarContainer}>
        <Panel className={styles.listButtonsPanel} mode="secondary">
          <div className={styles.listButtons}>
            {/* <ToolButton
              className={styles.button}
              appearance="default"
              icon={<TabBar_Main className={styles.imgIcon} />}
              onClick={onHomeClick}
            >
              <Typography.Label variant="medium">{HomeText}</Typography.Label>
            </ToolButton> */}

            <ToolButton
              className={styles.button}
              appearance="default"
              icon={<TabBar_Devices className={styles.imgIcon} />}
              onClick={onDevicesClick}
            >
              <Typography.Label variant="medium">
                {DevicesText}
              </Typography.Label>
            </ToolButton>

            <ToolButton
              className={styles.button}
              appearance="default"
              icon={<TabBar_Camera className={styles.imgIcon} />}
              onClick={onScanClick}
            >
              <Typography.Label variant="medium" className={styles.mont}>
                {ScanText}
              </Typography.Label>
            </ToolButton>

            {/* <ToolButton
              className={styles.button}
              appearance="default"
              icon={<TabBar_Responce className={styles.imgIcon} />}
              onClick={onResponceClick}
            >
              <Typography.Label variant="medium" className={styles.mont}>
                {ResponceText}
              </Typography.Label>
            </ToolButton> */}

            <ToolButton
              className={styles.button}
              appearance="default"
              icon={<TabBar_Profile className={styles.imgIcon} />}
              onClick={onSettingsClick}
            >
              <div ref={profileRef}>
                <Typography.Label variant="medium">
                  {SettingsText}
                </Typography.Label>
              </div>
            </ToolButton>
          </div>
        </Panel>
      </div>
    </>
  );
};
